export default {
  DEFAULT: 'Request not sent. Please try again.',
  ERROR_ON_MESSAGE_SEND: 'An error ocurred while trying to send your message',
  ERROR_LOADING_GROUPS: 'An error ocurred while trying to load the group list',
  ERROR_LOADING_PERMISSIONS:
    'An error ocurred while trying to load the permission list',
  ERROR_SAVING_TRY_AGAIN: 'An error occurred. Please try again.'
}
